import React from 'react';

const SqlSVG = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
    >
      <path
        d='M3.375 17V13.25M3.375 5.75V2M1.5 3.875H5.25M1.5 15.125H5.25M9.75 2.75L8.44935 6.13165C8.23785 6.68157 8.1321 6.95653 7.96762 7.18782C7.8219 7.3928 7.6428 7.57189 7.43782 7.71765C7.20653 7.88211 6.93157 7.98786 6.38164 8.19935L3 9.5L6.38164 10.8006C6.93157 11.0121 7.20653 11.1179 7.43782 11.2824C7.6428 11.4281 7.8219 11.6072 7.96762 11.8122C8.1321 12.0435 8.23785 12.3184 8.44935 12.8683L9.75 16.25L11.0506 12.8683C11.2621 12.3184 11.3679 12.0435 11.5324 11.8122C11.6781 11.6072 11.8572 11.4281 12.0622 11.2824C12.2935 11.1179 12.5684 11.0121 13.1183 10.8006L16.5 9.5L13.1183 8.19935C12.5684 7.98786 12.2935 7.8821 12.0622 7.71765C11.8572 7.57189 11.6781 7.3928 11.5324 7.18782C11.3679 6.95653 11.2621 6.68157 11.0506 6.13165L9.75 2.75Z'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SqlSVG;
